import React, { useState, useEffect } from 'react';

import toast from 'react-hot-toast';

// reactstrap components
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';

import { FaEdit, FaPlusCircle, FaTimesCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';

import api from 'services/api';
import BancoFinanciamento from 'models/BancoFinanciamento';
import BancoTaxaModel from '../../../models/ConfiguradorBancoTaxa';

const ConfiguradorBancoTaxa: React.FC = () => {
  const [taxas, setTaxas] = useState([] as BancoTaxaModel[]);
  const [listaBancos, setListaBancos] = useState([] as BancoFinanciamento[]);
  // eslint-disable-next-line prettier/prettier
  const [taxasEditing, setTaxasEditing] = useState({} as BancoTaxaModel);
  const [isEditing, setIsEditing] = useState(false);
  // const [isInserting, setIsInserting] = useState(false);

  const [formModalState, setFormModalState] = useState(false);
  const [modalStatusLogVisivel, setModalStatusLogVisivel] = useState(false);

  // async function listaTaxas() {
  //   console.log('chamou listaTaxas');
  //   const response = await api.get('/banco-taxa/');
  //   console.log('passou listaTaxas');

  //   setTaxas(response.data);
  // }

  async function listaTaxas() {
    try {
      const response = await api.get('/banco-taxa/');
      console.log('Response data:', response.data);
      setTaxas(response.data);
    } catch (error) {
      console.error('Error fetching taxas:', error);
      toast.error('Erro ao carregar taxas');
    }
  }

  async function buscaBancos() {
    try {
      const response = await api.get('/proposta-banco/');
      console.log('Response data:', response.data);
      setListaBancos(response.data);
    } catch (error) {
      console.error('Error fetching bancos:', error);
      toast.error('Erro ao carregar bancos');
    }
  }

  const bancoNome = (codigo: string): string => {
    const banco = listaBancos.find(b => b.codigo === codigo);
    return banco ? `${banco.codigo} - ${banco.razaoSocial}` : codigo;
  };

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaTaxas();
    buscaBancos();
  }, []);

  async function handleDelete(taxaId: number) {
    Swal.fire({
      title: `Deseja excluir o registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        await api.delete(`/banco-taxa/${taxaId}`, {});
        Swal.close();
        toast.success('Registro excluído');
        listaTaxas();
      }
    });
  }

  async function handleInsert() {
    setTaxasEditing({} as BancoTaxaModel);
    setIsEditing(false);
    setFormModalState(!formModalState);
  }

  function handleUpdate(itemTaxa: BancoTaxaModel) {
    setTaxasEditing(itemTaxa);
    setIsEditing(true);
    setFormModalState(!formModalState);
  }

  async function handleSaveTaxa() {
    // eslint-disable-next-line prettier/prettier
    const { id, codigoBanco, dataInicio, dataFim, formato, tipoTaxa, percTaxa } = taxasEditing;

    if (!codigoBanco || !formato || !tipoTaxa || !percTaxa) {
      toast.error(
        'Todos os campos marcados com * são de preenchimento obrigatório!',
      );
      return;
    }

    if (isEditing) {
      await api.put(`/banco-taxa/${taxasEditing.id}`, {
        codigoBanco: taxasEditing.codigoBanco,
        dataInicio: taxasEditing.dataInicio,
        dataFim: taxasEditing.dataFim,
        formato: taxasEditing.formato,
        tipoTaxa: taxasEditing.tipoTaxa,
        percTaxa: taxasEditing.percTaxa,
      });
    } else {
      await api.post(`/banco-taxa`, {
        codigoBanco: taxasEditing.codigoBanco,
        dataInicio: taxasEditing.dataInicio ?? new Date(),
        dataFim: taxasEditing.dataFim,
        formato: taxasEditing.formato,
        tipoTaxa: taxasEditing.tipoTaxa,
        percTaxa: taxasEditing.percTaxa,
      });
    }

    toast.success('Registro concluído');
    setFormModalState(false);
    setTaxasEditing({} as BancoTaxaModel);
    listaTaxas();
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={handleInsert}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col">
            {/* Modal edição */}
            <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={formModalState}
              toggle={() => setFormModalState(!formModalState)}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div
                      className="text-center text-muted mb-4"
                      hidden={!isEditing}
                    >
                      <small>{bancoNome(taxasEditing.codigoBanco || '')}</small>
                    </div>
                    <Form role="form">
                      <FormGroup className="mb-3" hidden={isEditing}>
                        <small>Código do Banco*</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-building" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="select"
                            value={taxasEditing.codigoBanco || ''}
                            onChange={e =>
                              setTaxasEditing({
                                ...taxasEditing,
                                codigoBanco: e.target.value,
                              })
                            }
                          >
                            <option value="">Selecione um banco</option>
                            {listaBancos.map(banco => (
                              <option key={banco.codigo} value={banco.codigo}>
                                {banco.codigo} - {banco.razaoSocial}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3" hidden>
                        <small>Data de Início *</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Data de Início"
                            value={
                              taxasEditing.dataInicio
                                ? new Date(taxasEditing.dataInicio)
                                    .toISOString()
                                    .slice(0, 10)
                                : ''
                            }
                            type="date"
                            onChange={text =>
                              setTaxasEditing({
                                ...taxasEditing,
                                dataInicio: new Date(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3" hidden>
                        <small>Data de Fim</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Data de Fim"
                            value={
                              taxasEditing.dataFim
                                ? new Date(taxasEditing.dataFim)
                                    .toISOString()
                                    .slice(0, 10)
                                : ''
                            }
                            type="date"
                            onChange={text =>
                              setTaxasEditing({
                                ...taxasEditing,
                                dataFim: new Date(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Formato *</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Formato"
                            value={taxasEditing.formato}
                            type="text"
                            onChange={text =>
                              setTaxasEditing({
                                ...taxasEditing,
                                formato: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Tipo de Taxa *</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Tipo de Taxa"
                            value={taxasEditing.tipoTaxa}
                            type="text"
                            onChange={text =>
                              setTaxasEditing({
                                ...taxasEditing,
                                tipoTaxa: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Percentual *</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Percentual"
                            value={taxasEditing.percTaxa}
                            type="number"
                            step="0.01" // Allows decimal values
                            min="0"
                            max="100"
                            onChange={text =>
                              setTaxasEditing({
                                ...taxasEditing,
                                percTaxa: Number(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={handleSaveTaxa}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Lista de Taxas</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Código</th>
                    <th hidden>Data de Início</th>
                    <th hidden>Data de Fim</th>
                    <th>Formato</th>
                    <th>Tipo de Taxa</th>
                    <th>Percentual</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {taxas.map(itemTaxa => (
                    <tr key={itemTaxa.id}>
                      <td className="py-2">
                        {bancoNome(itemTaxa.codigoBanco)}
                      </td>
                      <td className="py-2" hidden>
                        {itemTaxa.dataInicio}
                      </td>
                      <td className="py-2" hidden>
                        {itemTaxa.dataFim}
                      </td>
                      <td className="py-2">{itemTaxa.formato}</td>
                      <td className="py-2">{itemTaxa.tipoTaxa}</td>
                      <td className="py-2">{itemTaxa.percTaxa}</td>
                      <td className="py-2">
                        <div className="float-right">
                          <Button
                            size="sm"
                            className="btn-icon"
                            color="warning"
                            type="button"
                            onClick={() => {
                              handleUpdate(itemTaxa);
                            }}
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            size="sm"
                            className="btn-icon"
                            color="danger"
                            type="button"
                            onClick={() => {
                              handleDelete(itemTaxa.id);
                            }}
                          >
                            <FaTimesCircle />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ConfiguradorBancoTaxa;
